import { UsersIcon } from '@/icons';
import { Card } from 'antd';
import { useGetControlPanelStatesQuery } from '@/app/features/control-panel/dashboard/dashboard.api';
import useAuth from '@/hooks/useAuth';

export default function UsersCountCard() {
  const { organizationId } = useAuth();

  const { data, isLoading } = useGetControlPanelStatesQuery(
    { organization_id: organizationId },
    { skip: !organizationId },
  );
  const states = data?.data?.data;

  const cardData = [
    {
      icon: <UsersIcon size={32} className="text-white" />,
      value: states?.total_users,
      title: 'Total Users',
    },
    {
      icon: <UsersIcon size={32} className="text-white" />,
      value: states?.active_users,
      title: 'Active Users',
    },
    {
      icon: <UsersIcon size={32} className="text-white" />,
      value: states?.roles_created,
      title: 'Roles Created',
    },
    {
      icon: <UsersIcon size={32} className="text-white" />,
      value: states?.pending_access_requests,
      title: 'Pending Access Requests',
    },
  ];

  return (
    <>
      <div className="flex flex-nowrap justify-start overflow-x-auto hide-scrollbar md:grid md:grid-cols-2 md:overflow-visible lg:grid-cols-4 gap-6">
        {cardData.map((card, index) => (
          <Card
            key={index}
            className="dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-xl text-white shadow-md"
            styles={{ body: { padding: '22px' } }}
            loading={isLoading}
          >
            <div className="flex flex-col gap-3 !w-52 !md:w-[full]">
              {/* Icon */}
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                {card.icon}
              </div>

              {/* Value */}
              <div className="justify-start text-white text-xl font-bold">
                {card.value}
              </div>

              {/* Title */}
              <div className="text-white text-base font-normal">
                {card.title}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
